import { useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const footerLinks = [
    {
      title: 'サービス',
      links: [
        { name: 'Webサイト制作', href: '#services', type: 'section' },
        { name: 'オンライン配信', href: '#services', type: 'section' },
        { name: 'デジタルサイネージ', href: '#services', type: 'section' },
        { name: 'グラフィックデザイン', href: '#services', type: 'section' }
      ]
    },
    {
      title: '会社情報',
      links: [
        { name: '会社概要', href: '#about', type: 'section' },
        { name: '制作実績', href: '#portfolio', type: 'section' },
        { name: 'お知らせ', href: '/news', type: 'page' },
        { name: 'お問い合わせ', href: '#contact', type: 'section' }
      ]
    },
    {
      title: 'お問い合わせ',
      links: [
        { name: 'お問い合わせフォーム', href: '#contact', type: 'section' }
      ]
    }
  ];

  const socialLinks = [
    { icon: 'ri-twitter-x-line', href: '#', name: 'Twitter' },
    { icon: 'ri-facebook-line', href: '#', name: 'Facebook' },
    { icon: 'ri-instagram-line', href: '#', name: 'Instagram' },
    { icon: 'ri-linkedin-line', href: '#', name: 'LinkedIn' }
  ];

  const handleLinkClick = (link: { href: string; type: string }) => {
    if (link.type === 'page') {
      navigate(link.href);
    } else if (link.type === 'section') {
      const sectionId = link.href.replace('#', '');
      const isHome = location.pathname === '/' || location.pathname === '';
      if (!isHome) {
        navigate({ pathname: '/', hash: sectionId });
      } else {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const baseUrl = import.meta.env.BASE_URL || '';

  return (
    <footer className="bg-gray-900 text-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="inline-block bg-white rounded-lg px-3 py-2 mb-4">
              <img
                src={`${import.meta.env.BASE_URL}logo-text.png`}
                alt="WEBデザインくまチョップ"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              青森県弘前市を拠点とするWebデザイン事業所。
              お客様のビジネス成長をサポートする最適なWebソリューションを提供します。
            </p>
            {/* <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div> */}
          </div>

          {/* Footer Links */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.type === 'external' ? (
                      <a
                        href={link.href}
                        className="text-gray-400 hover:text-white transition-colors duration-300"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <button
                        onClick={() => handleLinkClick(link)}
                        className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
                      >
                        {link.name}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center relative overflow-hidden">
          <p className="text-gray-400 text-sm">
            © {currentYear} WEBデザインくまチョップ. All rights reserved.
          </p>
          {/* くまチョップ（白）右下から半身はみ出し・視認性確保 */}
          <div className="absolute right-0 bottom-0 w-28 h-32 opacity-45 pointer-events-none select-none flex items-end md:w-36 md:h-40" aria-hidden>
            <img src={`${baseUrl}kumachop-white.png`} alt="" className="w-full h-full object-contain object-bottom" style={{ clipPath: 'inset(0 0 45% 0)' }} />
          </div>
        </div>
      </div>
    </footer>
  );
}
